<div class="modal" data-iframe-size>
  <img class="icon" [src]="warningUrl">
  <h4 class="title">
    {{ 'i18n.dialog.error.title' | translate:errors.length }}
  </h4>

  @for (key of Object.keys(errors); track key) {
    <mat-dialog-content>
      <div class="content">
        <div>
          <strong>{{ key }}</strong>
          @for (error of errors[key]; track trackByTitle($index, error)) {
            <p>
              {{ error.text }}
            </p>
          }
        </div>
      </div>
    </mat-dialog-content>
  }

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>
